export default {"src":"/_next/static/media/icon-count-tournaments.e6d24cf7.svg","height":512,"width":512};